import { SubscriptionIntervalTypes } from './constants';

export const ALL_PLANS_OFFERED = [SubscriptionIntervalTypes.YEAR, SubscriptionIntervalTypes.MONTH];
export const ANNUAL_ONLY_PLANS_OFFERED = [SubscriptionIntervalTypes.YEAR];
export const MONTHLY_ONLY_PLANS_OFFERED = [SubscriptionIntervalTypes.MONTH];

// Open product question (ENG-2546): before campaigns, annual-only mode was reachable only
// through the Hotel Planner popup, so "annual only" and "no Hotel Planner card" were the
// same flag. Campaigns need annual-only *with* the card, so the two are now separate props.
// Flip this to true to restore the old coupling for campaign-triggered checkouts.
export const CAMPAIGN_ANNUAL_ONLY_HIDES_HOTEL_PLANNER_CARD = false;

const isSupportedInterval = (interval) => ALL_PLANS_OFFERED.includes(interval);

export const hasExplicitPlansOffered = (plansOffered) => {
    return Array.isArray(plansOffered) && plansOffered.some(isSupportedInterval);
};

export const resolvePlansOffered = ({ plansOffered, showHotelPlannerCard = true } = {}) => {
    const requested = Array.isArray(plansOffered) ? plansOffered.filter(isSupportedInterval) : [];

    if (requested.length > 0) {
        return [...new Set(requested)];
    }

    return showHotelPlannerCard ? ALL_PLANS_OFFERED : ANNUAL_ONLY_PLANS_OFFERED;
};

export const resolveDefaultInterval = (resolvedPlansOffered) => {
    return resolvedPlansOffered?.[0] || SubscriptionIntervalTypes.YEAR;
};

// Campaign checkout always renders both plans; the requested plan(s) lead so the modal —
// which preselects plansOffered[0] — defaults to the campaign's plan. The `plan` URL param
// is a preselection hint, not a restriction on which plans render.
export const resolveCampaignPlansOffered = (requestedPlans) => {
    const requested = Array.isArray(requestedPlans) ? requestedPlans.filter(isSupportedInterval) : [];
    return [...new Set([...requested, ...ALL_PLANS_OFFERED])];
};

export const offersInterval = (resolvedPlansOffered, interval) => {
    return (resolvedPlansOffered || []).includes(interval);
};

export const resolveCampaignHotelPlannerCard = (resolvedPlansOffered) => {
    const isAnnualOnly = resolvedPlansOffered?.length === 1 &&
        resolvedPlansOffered[0] === SubscriptionIntervalTypes.YEAR;

    return !(isAnnualOnly && CAMPAIGN_ANNUAL_ONLY_HIDES_HOTEL_PLANNER_CARD);
};
